import { render, staticRenderFns } from "./referrer-details.vue?vue&type=template&id=a60a547c"
import script from "./referrer-details.vue?vue&type=script&lang=js"
export * from "./referrer-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports